import React, { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import { Table, Image, Input, Space, Button, message, Tag, Empty, Spin, Form, Select} from 'antd'

import { AppContext } from '../App';

const saleReportThisBranch = (brachCode) => {

    const { user } = useContext(AppContext);
    const codeBranch = brachCode.brachCode

    const toDate = new Date();
    const currentYear = toDate.getFullYear();


    const API_URL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('Authentication');
    const [form] = Form.useForm();

    const [data, setData] = useState([])
    const [yearSelected, setYearSelected] = useState('')

    const date = new Date()
    const lastmonth = new Date(date.getFullYear(), date.getMonth() - 1, 1)

    const [listYear, setListYear] = useState([])


  const columns = [

    {
        title: 'เดือน',
        width: 100,
        dataIndex: 'monthName',
        key: 'monthName',
        fixed: 'left',
        render: (text, record) => (
          <div>
            {text}
          </div>
        )    
    },
    {
      title: 'รายได้ทั้งหมด (บาท)',
      width: 100,
      dataIndex: 'wallet',
      key: 'wallet',
      render: (text, record) => (
        <div>
          {(record.application + record.coin).toLocaleString('en-US')}
        </div>
      )    
    },
    {
        title: 'รายได้จากหยอดเหรียญ (บาท)',
        width: 90,
        dataIndex: 'coin',
        key: 'coin',
        render: (text, record) => (
          <div>
            {text ? (text).toLocaleString('en-US') : 0}
          </div>
        ),
    },
    {
        title: 'รายได้จากแอปพลิเคชั่น (บาท)',
        width: 80,
        dataIndex: 'application',
        key: 'application',
        render: (text, record) => (
          <div>
            {text ? (text).toLocaleString('en-US') : 0}
          </div>
        ),
    }
  ]

  const getListYear = async () =>{
    var listYearArr = []
    for(let index = 2023 ; index <= currentYear ; index++){
      listYearArr.push(index)
    }
    setListYear(listYearArr)
  }

  const changeYearSaleReport = async (value) =>{
    setYearSelected(value)
    setData('')
    fetchData(value)
  }

  const fetchData = async (year) => {

    if(!year){year = ''}
    try {
      const response = await axios.get(`${API_URL}saleReportThisBranch/${codeBranch}/${year}`, {
        headers: {
          'Authorization': `bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      const adjustedData = response.data.map((saleReport) => ({
        ...saleReport,
        key: saleReport.monthName,
      }));


      setData(adjustedData)
    } catch (error) {
      console.log('error', error)
    }
  }


  useEffect(() => {
    getListYear()
    if(data.length === 0 && yearSelected === ''){
        form.setFieldsValue({
            year: currentYear,
        });
        fetchData()
    }
  }, [data])

  return (
    <div className="fetch-event-table">
      {
        <Form form={form} >
        <Form.Item name="year" className='formItemWithNoMargin'>
        <Select style={{width:150}} optionFilterProp="label" onChange={changeYearSaleReport}>
          {listYear.map(yearItem => (
            <Select.Option key={yearItem} value={yearItem} >{yearItem}</Select.Option>
          ))}
        </Select>
        </Form.Item>
        </Form>
      }
      { data && data.length > 0 ? (
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{
            x: 400,
          }}
          rowKey="branchCode"
        />
      ) : <center><Spin /></center>}
    </div>
  )
}

export default saleReportThisBranch